export default {
	'border-collapse': true,
	'border-spacing': true,
	'caption-side': true,
	color: true,
	cursor: true,
	direction: true,
	'empty-cells': true,
	'font-family': true,
	'font-size': true,
	'font-style': true,
	'font-variant': true,
	'font-weight': true,
	'font-size-adjust': true,
	'font-stretch': true,
	font: true,
	'letter-spacing': true,
	'line-height': true,
	'list-style-image': true,
	'list-style-position': true,
	'list-style-type': true,
	'list-style': true,
	orphans: true,
	quotes: true,
	'tab-size': true,
	'text-align': true,
	'text-align-last': true,
	'text-decoration-color': true,
	'text-indent': true,
	'text-justify': true,
	'text-shadow': true,
	'text-transform': true,
	visibility: true,
	'white-space': true,
	widows: true,
	'word-break': true,
	'word-spacing': true,
	'word-wrap': true
};
